// noinspection AllyPlainJsInspection

import api from "../api"
import store from "../../store/index"

export async function getOptions() {
  const url = new URL(window.location.href)
  const headers = {}

  if (url.searchParams.get("AudicienID")) {
    headers.Authorization = `Bearer ${url.searchParams.get("AudicienID")}`
  }

  const requestData = await api.get("/api/v1/item/functioncontrol/options", {
    headers,
  })

  return requestData.data
}

export async function submitFunctionControl(functionControlData) {
  const url = new URL(window.location.href)
  const headers = {}

  if (url.searchParams.get("AudicienID")) {
    headers.Authorization = `Bearer ${url.searchParams.get("AudicienID")}`
  }
  const requestData = await api.post(
    "/api/v1/item/functioncontrol",
    {
      ...functionControlData,
    },
    {
      params: {
        customerID: store.state.customerID,
      },
      headers,
    }
  )
  return requestData
}
